import { createContext } from "react";

export interface WaitingTasksFilters {
  queueIds?: string[];
  customerIdentifier?: string;
}

export type AgentDashboardNavigationContextValue = [
  state: {
    isProfileMenuOpen: boolean;
    pendingWaitingTasksFilters: WaitingTasksFilters | null;
  },
  actions: {
    openProfileMenu(): void;
    closeProfileMenu(): void;
    toggleProfileMenu(): void;
    showWaitingTasks(filters: WaitingTasksFilters): void;
    clearPendingWaitingTasksFilters(): void;
  },
];

export const AgentDashboardNavigationContext = createContext<AgentDashboardNavigationContextValue>([
  { isProfileMenuOpen: false, pendingWaitingTasksFilters: null },
  {
    openProfileMenu: () => { },
    closeProfileMenu: () => { },
    toggleProfileMenu: () => { },
    showWaitingTasks: () => { },
    clearPendingWaitingTasksFilters: () => { },
  },
]);
